const CONTRACT_ADDRESSES = {
  DRIP_FAUCET: "0xFFE811714ab35360b67eE195acE7C10D93f89D8C",
  DRIP_FOUNTAIN: "0x4Fe59AdcF621489cED2D674978132a54d432653A",
};

export default CONTRACT_ADDRESSES;
